import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Tile } from '@carbon/react';
import { ArrowLeft } from '@carbon/icons-react';
import { useTheme } from '../context/ThemeContext';
import SubscriptionGate from '../components/SubscriptionGate';
import { useSubscription } from '../hooks/useSubscription';
import GatewayAdminView from '../features/gateway-admin/components/GatewayAdminView';
import './GatewayConfigPage.scss';

const GatewayConfigPage = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const { hasActiveSubscription } = useSubscription();

  const bg = isDark ? '#161616' : '#f4f4f4';
  const textPrimary = isDark ? '#f4f4f4' : '#161616';

  return (
    <SubscriptionGate
      feature="gateway configuration and OTA commands"
      disabled={!hasActiveSubscription}
      showChildrenGreyed
      customMessage="You need an active subscription to configure gateways and send OTA commands."
    >
      <div className="gateway-config-page" style={{ background: bg, minHeight: '100vh', padding: '24px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <Button
            kind="ghost"
            renderIcon={ArrowLeft}
            onClick={() => navigate('/dashboard/gateways')}
            style={{ color: textPrimary, marginBottom: '16px' }}
          >
            Back to Gateways
          </Button>

          <Tile style={{ padding: '24px', marginBottom: '24px' }}>
            <GatewayAdminView configOnly />
          </Tile>
        </div>
      </div>
    </SubscriptionGate>
  );
};

export default GatewayConfigPage;
